import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import axios from "../../../utils/axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import SettlementEftRequestDetails from "./SettlementEftRequestDetails";


const SettlementEftRequest = () => {
  const [companies, setCompanies] = useState([]); // store API response
  const [selectedCompany, setSelectedCompany] = useState(""); // store selected company
  const [year, setYear] = useState(new Date().getFullYear());
  const [signatories, setSignatories] = useState([]);
  const [primarySelected, setPrimarySelected] = useState(null);
  const [secondarySelected, setSecondarySelected] = useState(null);
  const [subject, setSubject] = useState("Electronic Fund Transfer Request.");
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [claimsData, setClaimsData] = useState([]);
  const [settlementNo, setSettlementNo] = useState("All"); // 👈 default value
  const [settlementList, setSettlementList] = useState([]);

  // const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    // Call API when component loads
    axios
      .get("/bank-bo/list-all/Cash")
      .then((res) => {
        if (res.data.success) {
          setCompanies(res.data.payload); // save API data to state
        }
      })
      .catch((err) => {
        console.error("Error fetching companies:", err);
      });
  }, []);

  useEffect(() => {
    const fetchSignatories = async () => {
      try {
        const res = await axios.get("/signatories");
        if (res.data.success) {
          setSignatories(res.data.payload);
        }
      } catch (error) {
        console.error("Error fetching signatories:", error);
      }
    };

    fetchSignatories();
  }, []);

  useEffect(() => {
  const fetchSettlementNumbers = async () => {
    try {
      const res = await axios.get("/fund-transfer-requests/get-approved-settled-no");

      if (res.data?.success) {
        setSettlementList(res.data.payload);
      }
    } catch (error) {
      console.error("Error loading settlement numbers", error);
    }
  };

  fetchSettlementNumbers();
}, []);


  const primaryOptions = signatories.filter(
    (s) => s.signatoryType === "Primary",
  );
  const secondaryOptions = signatories.filter(
    (s) => s.signatoryType === "Secondary",
  );


const fetchClaimsData = async () => {
  const page_no = 1;
  const page_limit = 500;
  const searchBy = "All";
  const searchKeyword = "All";
  const settlementPart = "All";
  const dividendType = "Cash";
  const claimStatus = "Approved";

  try {
    const res = await axios.get(
      `/settlement/get-claims?page_no=${page_no}&page_limit=${page_limit}&dividend_type=${dividendType || ""}&claim_status=${claimStatus || ""}&filter_type=${searchBy || ""}&filter_value=${searchKeyword || ""}&settlement_no=${settlementNo || ""}&settlement_part=${settlementPart || ""}`
    );

    if (res.data?.success) {
      setClaimsData(res.data.payload.data || []);
      
    }
    
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

// ✅ 2. Call on initial load
useEffect(() => {
  fetchClaimsData();
}, [settlementNo]);

const totalAmount = claimsData.reduce(
  (sum, row) => sum + Number(row.totalAmount || 0),
  0
);


const handleSubmit = async () => {
  if (!selectedCompany) {
    Swal.fire("Missing Info", "Please select a company.", "warning");
    return;
  }
  if (!primarySelected || !secondarySelected) {
    Swal.fire(
      "Missing Info",
      "Please select both Primary and Secondary signatories.",
      "warning"
    );
    return;
  }

 

  const payload = {
    refNo: `CMSF/ACC/${
      selectedCompany ? selectedCompany.tradeCode : "XXX"
    }/${year}/`,
    date: selectedDate,
    subject,
    primarySignatoryId: primarySelected.id,
    secondarySignatoryId: secondarySelected.id,
    bankBoId: selectedCompany.id,
    count: claimsData.length,
    totalAmount,
    dividendType: "Cash",
    claimStatus: "Settled",
    eftType: "Cash",
    settlementNo: settlementNo,
  };

  // Step 1: Ask for confirmation
  const confirmResult = await Swal.fire({
    title: "Are you sure?",
    html: `
  <p>Number of Investors: <strong>${claimsData.length}</strong></p>
  <p>Total Amount: <strong>${totalAmount.toLocaleString()}</strong></p>
  
`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Submit",
    cancelButtonText: "Cancel",
  });

  if (!confirmResult.isConfirmed) return;

  try {
    // Step 2: Call API
    const res = await axios.post("/fund-transfer-requests", payload);

    const { success, payload: responsePayload } = res.data;

    // Step 3: Check API response conditions
    if (
      success &&
      responsePayload?.status === "success" &&
      responsePayload?.statusCode === 200
    ) {
      await Swal.fire({
        title: "Success!",
        text: responsePayload?.message || "Submitted successfully!",
        icon: "success",
        confirmButtonText: "OK",
      });

      // Reset and refresh data
      // setSelectedCompany(null);
      // setPrimarySelected(null);
      // setSecondarySelected(null);
      // setSettlementNo("All");
      // fetchClaimsData();
      
    window.location.href = "/app/eft/fundTransferRequestList";
    } else {
      Swal.fire(
        "Error",
        responsePayload?.message || "Submission failed!",
        "error"
      );
    }
  } catch (error) {
    console.error("Error submitting:", error);
    Swal.fire("Error", "Something went wrong!", "error");
  }
};


  return (
    <>
      {/* 🔹 Title + Add Button */}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ marginBottom: "10px" }}
      >
        {/* Left side: title */}
        <Grid item>
          <PageTitle title="Electronic Fund Transfer Form (Settlement)" />
        </Grid>

        {/* Right side: buttons in one line */}
        <Grid item>
          <Grid container spacing={2}>
            <Grid item>
              <Link to="/app/eft/fundTransferRequestList">
                <Button variant="contained" color="primary">
                  Back to Fund Transfer List
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

     <Grid container spacing={1}>
  {/* Company Dropdown */}
  <Grid item lg={3} md={6} sm={12} xs={12}>
    <FormControl fullWidth>
      <InputLabel id="company-label">Bank Name</InputLabel>
      <Select
        labelId="company-label"
        value={selectedCompany?.id || ""}
        onChange={(e) => {
          const comp = companies.find((c) => c.id === e.target.value);
          setSelectedCompany(comp);
        }}
      >
        {companies.map((company) => (
          <MenuItem key={company.id} value={company.id}>
            {company.companyName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

  {/* Settlement No Dropdown */}
  <Grid item lg={3} md={6} sm={12} xs={12}>
  <FormControl fullWidth>
    <InputLabel id="settlement-label">Settlement No</InputLabel>

    <Select
      labelId="settlement-label"
      value={settlementNo}
      onChange={(e) => setSettlementNo(e.target.value)}
    >
      <MenuItem value="All">All</MenuItem>

      {settlementList.map((item) => (
        <MenuItem key={item.settlementNo} value={item.settlementNo}>
          {item.settlementNo} 
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>

</Grid>

      <Paper style={{ padding: 15, marginTop: 2 }}>
        {/* Header */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            <Typography variant="body2" style={{ marginRight: 3 }}>
              Ref No: CMSF/ACC/
              {selectedCompany ? selectedCompany.tradeCode : "XXX"}/{year}/
            </Typography>
          </Box>

          <TextField
            label="Date"
            type="date"
            size="small"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            InputLabelProps={{
              shrink: true, // ensures the label doesn't overlap
            }}
          />
        </Grid>

        {/* Address (Dynamic) */}
        <Box mt={1}>
          <Typography variant="body2">Manager</Typography>
          <Typography variant="body2">
            {selectedCompany ? selectedCompany.companyName : "Company Name"}
          </Typography>
          <Typography variant="body2">
            {selectedCompany ? selectedCompany.branch : "Branch Name"}
          </Typography>
          <Typography variant="body2">
            {selectedCompany ? selectedCompany.address : "Address Line"}
          </Typography>
        </Box>

        {/* Subject */}

        <Grid container spacing={2} style={{ marginTop: 5 }}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="subject-label">Subject</InputLabel>
              <Select
                labelId="subject-label"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              >
                <MenuItem value="Electronic Fund Transfer Request.">
                  Electronic Fund Transfer Request.
                </MenuItem>
                <MenuItem value="RTGS Fund Transfer Request.">
                  RTGS Fund Transfer Request.
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Body */}
        <Box>
          <Typography variant="body2" paragraph>
            Dear Sir,
          </Typography>
          <Typography variant="body2" paragraph>
            Please transfer the following fund from our special notice deposit
            bank account no.{" "}
            <b>
              {selectedCompany ? selectedCompany.accountNumber : "___________"}
            </b>{" "}
            maintained with your bank to the respective bank account of the
            beneficiaries as per the information given below:
          </Typography>
        </Box>
          <Grid item xs={12} md={12}>
        <SettlementEftRequestDetails
       claimsData={claimsData}
        totalAmount={totalAmount}
      
       
    />
    </Grid>

        <Box mt={2}>
          <Typography variant="body2" paragraph>
            Kindly execute the fund transfer instruction as stated above by
            debiting our bank account and transmit us the transfer advice in due
            course.
          </Typography>
          <Typography variant="body2">Thanks and best regards,</Typography>
        </Box>

        <Grid
          container
          justifyContent="space-between"
          style={{ marginTop: 30 }}
        >
          {/* Left Side → Primary */}

          <Grid container spacing={2} style={{ marginTop: 5 }}>
            <Grid item xs={4} style={{ textAlign: "left" }}>
              <Autocomplete
                options={secondaryOptions}
                getOptionLabel={(option) => option.fullName} // ✅ show only name
                value={secondarySelected}
                onChange={(event, newValue) => setSecondarySelected(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Secondary Signatory"
                    size="small"
                    fullWidth
                  />
                )}
              />

              {secondarySelected && (
                <>
                  <Typography variant="body2" style={{ marginTop: 5 }}>
                    <b>({secondarySelected.fullName})</b>
                  </Typography>
                  <Typography variant="body2">
                    {secondarySelected.designation}
                  </Typography>
                </>
              )}
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <Autocomplete
                options={primaryOptions}
                getOptionLabel={(option) => option.fullName}
                value={primarySelected}
                onChange={(event, newValue) => setPrimarySelected(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Primary Signatory"
                    size="small"
                    fullWidth
                  />
                )}
              />

              {primarySelected && (
                <>
                  <Typography variant="body2" style={{ marginTop: 5 }}>
                    <b>({primarySelected.fullName})</b>
                  </Typography>
                  <Typography variant="body2">
                    {primarySelected.designation}
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Box mt={2} textAlign="center">
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </>
  );
};

export default SettlementEftRequest;
